import { Tabs, TabsProps } from "antd"
import { PageCard } from "src/common/styles/styles"
import { CustomerData } from "./CustomerData"
import { SystemDescriptions } from "src/common/descriptions"
import { CustomerContracts } from "./CustomerContracts"
import { CustomerPayments } from "./CustomerPayments"
import { CustomerAccountPayables } from "./CustomerAccountPayables"
import { Customer } from "src/common/models/customer"
import { useParams } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "src/state/reducer"
import { serviceLoading } from "src/common/apiLoader/state/selection"
import { GET_CUSTOMER_BY_ID_API } from "../state/actionTypes"
import { useEffect } from "react"
import { getCustomerByIdApi } from "../state/action"

interface ReduxProps {
    currentCustomer?: Customer
    isLoadingCustomer: boolean
}

export const CustomerProfile = () => {
    const dispatch = useDispatch()

    const { id: customerId } = useParams<{ id: string }>();

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        currentCustomer: state.customer.currentCustomer,
        isLoadingCustomer: serviceLoading(state, [GET_CUSTOMER_BY_ID_API]),
    }))

    useEffect(() => {
        if (customerId && !reduxProps.currentCustomer) {
            dispatch(getCustomerByIdApi(Number(customerId)))
        }
    }, [])

    const descriptions = SystemDescriptions.PAGES.CUSTOMER.CUSTOMER_PROFILE
    // const customerDescriptions = SystemDescriptions.PAGES.CUSTOMER.CREATE

    const items: TabsProps['items'] = [
        {
            key: 'CONTRACTS',
            label: descriptions.TABS.CONTRACTS,
            children: <CustomerContracts />,
        },
        {
            key: 'PAYMENT_RECORDS',
            label: descriptions.TABS.PAYMENT_RECORDS,
            children: <CustomerPayments />,
        },
        {
            key: 'CUSTOMER_ACCOUNT_PAYABLES',
            label: descriptions.TABS.CUSTOMER_ACCOUNT_PAYABLES.TITLE,
            children: <CustomerAccountPayables />,
        },
        {
            key: 'INFO',
            label: descriptions.TABS.DATA,
            children: <CustomerData />,
        },
    ];

    const renderTabs = () => (
        <Tabs defaultActiveKey="CONTRACTS" items={items} />
    )

    // const DESCRIPTION_ITEMS: DescriptionsProps['items'] = [
    //     {
    //         key: 'name',
    //         label: customerDescriptions.FORM.NAME.LABEL,
    //         children: <span>{reduxProps.currentCustomer?.name}</span>,
    //     },
    //     {
    //         key: 'phone',
    //         label: customerDescriptions.FORM.PHONE.LABEL,
    //         children: <span>{reduxProps.currentCustomer?.phone}</span>,
    //     },
    //     {
    //         key: 'invoiceReceiverId',
    //         label: customerDescriptions.FORM.INVOICE_RECEIVER_ID.LABEL,
    //         children: <span>{reduxProps.currentCustomer?.nit}</span>,
    //     },
    //     {
    //         key: 'manager',
    //         label: customerDescriptions.FORM.MANAGER.LABEL,
    //         children: <span>{reduxProps.currentCustomer?.manager}</span>,
    //     },
    //     {
    //         key: 'address',
    //         label: customerDescriptions.FORM.ADDRESS.LABEL,
    //         children: <span>{reduxProps.currentCustomer?.address}</span>,
    //     },
    // ];

    // const renderCustomerData = () => (
    //     <Row gutter={[16, 16]}>
    //         <Col24>
    //             <Descriptions
    //                 title={descriptions.TABS.DATA}
    //                 items={DESCRIPTION_ITEMS}
    //             />
    //         </Col24>
    //         <Divider />
    //     </Row>
    // )

    return (
        < PageCard
            size="small"
            title={reduxProps.currentCustomer?.name || ""}
        >
            {
                // renderCustomerData()
            }
            {renderTabs()}
        </PageCard>
    )
}
